import { useEffect, useRef, type ReactNode } from "react";

/** Native modal semantics provide focus containment, Escape and focus restoration. */
export function Dialog({ title, children, onClose, className = "" }: { readonly title: string; readonly children: ReactNode; readonly onClose: () => void; readonly className?: string }) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const node = ref.current; const previous = document.activeElement; node?.showModal();
    return () => { node?.close(); if (previous instanceof HTMLElement && previous.isConnected) previous.focus(); };
  }, []);
  return <dialog ref={ref} className={`workspace-dialog ${className}`} aria-label={title} onCancel={(event) => { event.preventDefault(); onClose(); }}>
    <div className="dialog-heading"><h2>{title}</h2><button type="button" aria-label="关闭对话框" onClick={onClose}>×</button></div>
    {children}
  </dialog>;
}
